export default __webpack_public_path__ + "static/unreal_game_banner-bfa4efdd34bca4e9da951f64cafab731.webp";